/**
 * @file 路由配置
 */


const guide = {
    path: 'guide',
    name: 'guide',
    meta: {
        requiresAuth: true,
        label: '政策资讯'
    },
    component(resolve) {
        require.ensure([], () => resolve(require('@/modules/audit/guide')));
    }
};
const country = {
    path: 'country',
    name: 'country',
    meta: {
        requiresAuth: true,
        label: '招投标项目'
    },
    component(resolve) {
        require.ensure([], () => resolve(require('@/modules/audit/country')));
    }
};
const purchase = {
    path: 'purchase',
    name: 'purchase',
    meta: {
        requiresAuth: true,
        label: '采购项目'
    },
    component(resolve) {
        require.ensure([], () => resolve(require('@/modules/audit/purchase')));
    }
};
// const mall = {
//     path: 'mall',
//     name: 'mall',
//     meta: {
//         requiresAuth: true,
//         label: '数据商城'
//     },
//     component(resolve) {
//         require.ensure([], () => resolve(require('@/modules/audit/mall')));
//     }
// };
const bid = {
    path: 'bid',
    name: 'bid',
    meta: {
        requiresAuth: true,
        label: '发布招标'
    },
    component(resolve) {
        require.ensure([], () => resolve(require('@/modules/audit/bid')));
    }
};

export default {
    path: '/audit',
    name: 'audit',
    redirect: '/audit/guide',
    icon: 'el-icon-document',
    meta: {
        requiresAuth: true,
        label: '审核管理'
    },
    component(resolve) {
        require.ensure([], () => resolve(require('@/modules/audit')));
    },
    children: [guide, country, purchase, bid]
};
